module.exports = __webpack_public_path__ + "img/introduce.9c73e049.png";